import { render, staticRenderFns } from "./PricingPage.vue?vue&type=template&id=32515657&scoped=true&"
import script from "./PricingPage.vue?vue&type=script&lang=js&"
export * from "./PricingPage.vue?vue&type=script&lang=js&"
import style0 from "./PricingPage.vue?vue&type=style&index=0&id=32515657&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32515657",
  null
  
)

export default component.exports